import { render, staticRenderFns } from "./HistoryUserListKPI.vue?vue&type=template&id=029ff8a4&scoped=true&"
import script from "./HistoryUserListKPI.vue?vue&type=script&lang=js&"
export * from "./HistoryUserListKPI.vue?vue&type=script&lang=js&"
import style0 from "./HistoryUserListKPI.vue?vue&type=style&index=0&id=029ff8a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029ff8a4",
  null
  
)

export default component.exports